export default __webpack_public_path__ + "images/68a1cc2390a778d4deb069ece5f4c8bd.jpg";